import { useEffect, useRef } from "react";
import { trackGoal } from "@/utils/analytics";

const TIME_MILESTONES = [
  { seconds: 15, label: "15s" },
  { seconds: 30, label: "30s" },
  { seconds: 60, label: "60s" },
  { seconds: 120, label: "120s" },
] as const;

export const useTimeTracking = () => {
  const trackedMilestones = useRef<Set<number>>(new Set());
  const startTime = useRef<number>(Date.now());
  const intervalRef = useRef<NodeJS.Timeout>(undefined);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - startTime.current) / 1000);

      for (const { seconds, label } of TIME_MILESTONES) {
        if (elapsedSeconds >= seconds && !trackedMilestones.current.has(seconds)) {
          trackedMilestones.current.add(seconds);
          trackGoal(`time_${label}`, {
            timeOnPage: elapsedSeconds,
            milestone: label,
          });
        }
      }
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
};
